import React from 'react';
import PropTypes from 'prop-types';
import { Resizable } from 'react-resizable';

const withResizable = (WrappedComponent, withResizableProps = {}) => {
  class WrappedComponentWithResizable extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isResizing: false };
      this.onAttributesChanged = this.onAttributesChanged.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onResizeStart = this.onResizeStart.bind(this);
      this.onResizeStop = this.onResizeStop.bind(this);
    }

    onAttributesChanged(attributes) {
      this.props.onAttributesChanged(this.props.id, attributes);
    }

    onResize(event, { size }) {
      this.onAttributesChanged({
        width: size.width,
        height: withResizableProps.isSquare ? size.width : size.height,
      });
    }

    onResizeStart() {
      this.setState({ isResizing: true });
    }

    onResizeStop() {
      this.setState({ isResizing: false });
    }

    render() {
      const resizeAxis = this.props.resizable ? 'both' : 'none';

      const minWidth = this.props.minWidth || withResizableProps.minWidth || 125;
      let minHeight = this.props.minHeight || withResizableProps.minHeight || 25;
      const maxHeight = withResizableProps.maxHeight || this.props.maxHeight;
      let maxWidth = withResizableProps.maxWidth || this.props.maxWidth;
      if (withResizableProps.isSquare) {
        minHeight = minWidth;
        maxWidth = maxHeight;
      }

      // Note on height below: We don't always know height right away, but Resizable throws a
      // useless warning if it's not set so defaulting it to Infinity works around the
      // problem per the post here:
      // https://github.com/STRML/react-resizable/issues/69#issuecomment-321082718
      const resizableProps = {
        width: this.props.width,
        height: this.props.height || Infinity,
        axis: resizeAxis,
        onResize: this.onResize,
        onResizeStart: this.onResizeStart,
        onResizeStop: this.onResizeStop,
        maxConstraints: [maxWidth, maxHeight],
        minConstraints: [minWidth, minHeight],
      };

      return (
        <Resizable {...resizableProps}>
          <WrappedComponent
            {...this.props}
            isResizing={this.state.isResizing}
          />
        </Resizable>
      );
    }
  }

  WrappedComponentWithResizable.defaultProps = {
    resizable: true,
    width: 0,
    height: 0,
    minWidth: 0,
    minHeight: 0,
    maxWidth: Infinity,
    maxHeight: Infinity,
  };
  WrappedComponentWithResizable.propTypes = {
    id: PropTypes.string.isRequired,
    resizable: PropTypes.bool,
    onAttributesChanged: PropTypes.func.isRequired,
    maxHeight: PropTypes.number,
    maxWidth: PropTypes.number,
    minWidth: PropTypes.number,
    minHeight: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  };

  return WrappedComponentWithResizable;
};

export default withResizable;



// WEBPACK FOOTER //
// ./src-react/withResizable/index.jsx